import { Result } from "../../../models/Result";
import { httpService } from "../../HttpService";
import { SelectItem } from "../../../models/SelectItem";
import { UserDelete } from "../../../models/User";

class AuthUsersApiService {
    private baseUrl: string = process.env.REACT_APP_AUTH_API_BASE_URL ?? process.env.REACT_APP_API_BASE_URL ?? "";
    private baseApiUrl: string = `${this.baseUrl}`;
    private path: string = "User";

    getSelectItem = async (): Promise<Result<SelectItem[]>> => await httpService.get<SelectItem[]>(`${this.path}/all`, { baseURL: this.baseApiUrl });

    softDeleteUser = async (user: UserDelete): Promise<Result<void>> => await httpService.post(`${this.baseApiUrl}/user/soft-delete`, user);

    restoreUser=async (user: UserDelete): Promise<Result<void>> => await httpService.post(`${this.baseApiUrl}/user/undo-soft-delete`, user);

    hardDeleteUser = async (user: UserDelete): Promise<Result<void>> => await httpService.delete(`${this.baseApiUrl}/user/delete`,{},user);
}

const authUsersApiService = new AuthUsersApiService();

export { authUsersApiService };
